import { Observable } from 'rxjs';

import { Policy, PolicySummary } from '@amfam/policy/models';

export interface TypedWorker {
  getEndpoint();
  getPolicy(url: string, policySummary?: PolicySummary): Observable<Policy>;
  loadModel(json: unknown, policySummary?: PolicySummary): Policy;
}
